export default {
    Basecamp: 'Basecamp'
  }
  